import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import "bootstrap-icons/font/bootstrap-icons";

import APIService from "@/services/APIService";

const app = createApp(App);

APIService.init(app);

app.use(store);
app.use(router);

app.mount("#app");

